import { IInitAction } from './init'
import { IAnyObject } from '../services/common'

export enum types {
  MODAL_OPEN = 'MODAL_OPEN',
  MODAL_CLOSE = 'MODAL_CLOSE',
}

export enum Modals {
  deleteConfirmModal = 'deleteConfirmModal',
  deleteStatusModal = 'deleteStatusModal',
  slugValidationModal = 'slugValidationModal',
}

export interface IModalOpenAction {
  type: types.MODAL_OPEN
  id: Modals
  options?: IAnyObject
}

export interface IModalCloseAction {
  type: types.MODAL_CLOSE
}

export type ModalActionsType =
  | IModalOpenAction
  | IModalCloseAction
  | IInitAction

export interface IModal {
  id?: Modals
  options?: IAnyObject
}
